<template>
  <!-- TicketSearchForm -->
      <el-form
        label-width="80px"
        :inline="true"
        style="padding:15px 0 10px 0;">
        <transition :duration="350">
          <el-form-item label="工单状态" style="width: 100%;" v-show="advancedSearch">
            <el-checkbox-group v-model="searchData.orderStatus">
              <el-checkbox v-for="st in orderStatusList"
                :label="st.value"
                :key="st.value">{{st.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </transition>

        <transition :duration="300">
          <el-form-item label="创建于"
            v-show="advancedSearch">
            <el-date-picker v-model="ticketCreateTimeRange"
              :picker-options="datePickerOptions"
              start-placeholder="开始"
              end-placeholder="结束"
              style="width: 240px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change='ticketCreateTimeChange'/>
          </el-form-item>
        </transition>

        <transition :duration="450">
          <el-form-item label="更新于"
            v-show="advancedSearch">
            <el-date-picker v-model="ticketUpdateTimeRange"
              :picker-options="datePickerOptions"
              start-placeholder="开始"
              end-placeholder="结束"
              style="width: 240px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change='ticketUpdateTimeChange'/>
          </el-form-item>
        </transition>

        <transition :duration="250">
          <el-form-item label="创建人" v-show="advancedSearch">
            <DealUserSearch css="width: 240px;" @change="onCreatorIdChange" ref="creatorUser_3"/>
          </el-form-item>
        </transition>

        <transition :duration="200">
          <el-form-item label="处理人" v-show="advancedSearch">
            <DealUserSearch css="width: 240px;" @change="onDealUserIdChange" ref="assignUser_3"/>
          </el-form-item>
        </transition>

        <el-form-item label="工单标题">
          <el-input v-model="searchData.orderTitle"
            @keyup.enter.native="doSearch"
            placeholder="工单标题/内容/编号"
            style="width: 240px;"
            clearable />
        </el-form-item>

        <el-form-item label="项目" v-show="advancedSearch">
          <TicketProjectSelect style="width: 240px;"
            v-model="searchData.projectIds"/>
        </el-form-item>

        <transition :duration="200">
          <el-form-item label="抄送人" v-show="advancedSearch">
            <DealUserSearch css="width: 240px;" @change="onTicketCcChange" ref="ticketCc_71"/>
          </el-form-item>
        </transition>

        <transition :duration="150">
          <el-form-item label="工单类型" v-show="advancedSearch">
              <TicketTypeCascader
                css="width: 240px;"
                v-model="searchData.orderType"/>
          </el-form-item>
        </transition>

        <!-- 最后一个将工单标记为已解决的人 -->
        <el-form-item label="解决人"
          title="最后一个将工单标记为已解决的人"
          v-show="advancedSearch">
          <DealUserSearch css="width: 240px;" @change="updateSolveUserId" ref="solveUser_3"/>
        </el-form-item>

        <transition :duration="100">
          <el-form-item label="优先级" v-show="advancedSearch">
            <el-select v-model="searchData.orderPriority"
              clearable
              placeholder="请选择优先级" style="width: 240px;">
              <el-option v-for="(ll) in orderPriorityList"
                :key="ll.id" :label="ll.name" :value="ll.id"></el-option>
            </el-select>
          </el-form-item>
        </transition>

        <transition :duration="50">
          <el-form-item label="标签" v-show="advancedSearch">
            <el-input v-model="searchData.tag"
              @keyup.enter.native="doSearch"
              placeholder="输入标签"
              style="width:240px;"
              clearable/>
          </el-form-item>
        </transition>

        <transition :duration="400">
          <el-form-item label="商家" v-show="advancedSearch">
            <MerchantSearch v-model="searchData.merchantId" style="width:240px;"/>
          </el-form-item>
        </transition>

        <el-form-item style="margin-left:80px;width:240px;">
          <el-button title="查询符合条件的工单[98]" style="width:70px;"
            @click="doSearch" type="primary">搜索</el-button>

          <el-button title="清空搜索条件" style="width:70px;"
            @click="resetSearch">重置</el-button>

          <!-- 用CSS隐藏掉,可用 Widget 显示出来 -->
          <el-button
            class="TicketNewBtn"
            title="提交新工单" style="width:70px;"
            @click="onNewTicketBtnClick">新增</el-button>

          <!--自定义按钮位置-->
          <TicketWidgetGroup group="AfterTicketSearchButton"/>
        </el-form-item>

        <el-form-item style="margin-left:80px;width:240px;">
          <el-button style="width:100px;margin-right:30px;"
            @click="clickAdvancedSearch">{{advancedSearch ? '简单搜索' : '高级搜索'}}</el-button>

          <TicketExportButton @export="doExport"/>
        </el-form-item>

        <!--自定义按钮位置-->
        <el-form-item style="margin-left:80px;width:240px;">
          <TicketWidgetGroup group="AfterTicketSearchForm"/>
        </el-form-item>
      </el-form>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil';
import moment from 'moment';

export default {
    name : 'TicketSearchForm',

    props : ['value'],

    data() {
        return {
          datePickerOptions: {
            shortcuts: [
              {
                text: '今天',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().toDate(), moment().toDate()))
                }
              },
              {
                text: '昨天',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()))
                }
              },
              {
                text: '近三天',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().subtract(2, 'days').toDate(), moment().toDate()))
                }
              },
              {
                text: '本周',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().startOf('week').toDate(), moment().toDate()))
                }
              },
              {
                text: '上周',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().startOf('week').subtract(1, 'weeks').toDate(), moment().startOf('week').toDate()))
                }
              },
              {
                text: '近一周',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().subtract(1, 'weeks').toDate(), moment().toDate()))
                }
              },
              {
                text: '本月',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().startOf('months').toDate(), moment().toDate()))
                }
              },
              {
                text: '上月',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().startOf('months').subtract(1, 'months').toDate(), moment().startOf('months').toDate()))
                }
              },
              {
                text: '近一月',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().subtract(1, 'months').toDate(), moment().toDate()))
                }
              },
              {
                text: '近三月',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment().subtract(3, 'months').toDate(), moment().toDate()))
                }
              },

              // -----------------------------------
              {
                text: '三天前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().subtract(3, 'days').toDate()))
                }
              },
              {
                text: '一周前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().subtract(7, 'days').toDate()))
                }
              },
              {
                text: '两周前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().subtract(14, 'days').toDate()))
                }
              },
              {
                text: '本周前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().startOf('week').toDate()))
                }
              },
              {
                text: '一个月前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().subtract(1, 'months').toDate()))
                }
              },
              {
                text: '三个月前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().subtract(3, 'months').toDate()))
                }
              },
              {
                text: '本月前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().startOf('month').toDate()))
                }
              },
              {
                text: '半年前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().subtract(6, 'months').toDate()))
                }
              },
              {
                text: '一年前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().subtract(12, 'months').toDate()))
                }
              },
              {
                text: '今年前',
                onClick(vm) {
                  vm.$emit('pick', new Array(moment(0).toDate(), moment().startOf('year').toDate()))
                }
              }
            ]
          },

          orderStatusList: [], //工单状态
          ticketCreateTimeRange: [], // 选择日期
          ticketUpdateTimeRange: [], // 选择日期
          advancedSearch : "false" != ( localStorage.getItem(CacheUtil.AdvancedSearch) || "false" ) ,
          searchData : {}
        }
    },

    methods : {
        // 点击新建工单按钮
        onNewTicketBtnClick() {
          console.log('#297 onNewTicketBtnClick', 'document.referrer=', document.referrer, 'this.$route=', this.$route, 'location.href=', location.href);

          if ( document.referrer && document.referrer.indexOf('ticket-vue/merchant-ticket') > 0 ) { // 商家端 & 客服端嵌入的工单列表页
            location.href="/ticket-vue/new-ticket?297"; // 直接跳转到新建页
            return;
          }

          if ( '/ticket-vue/merchant-ticket' == this.$route.path ) {
            location.href = "/ticket-vue/new-ticket?303"; // 直接跳转到新建页
            return;
          }

          // 其他 展示弹窗
          this.$parent.$parent.$refs.newTicketDialog.showNewTicketDialog();
        },

        setSearchData( _v ) {
          this.searchData = _v;

          setTimeout(() => {
            if (!!this.$refs.creatorUser_3) {
              this.$refs.creatorUser_3.setUserId(this.searchData.creatorId);
            }

            if (!!this.$refs.ticketCc_71) {
              this.$refs.ticketCc_71.setUserId(this.searchData.ticketCcId);
            }

            if (!!this.$refs.assignUser_3) {
              this.$refs.assignUser_3.setUserId(this.searchData.dealUserId);
            }

            if (!!this.$refs.solveUser_3) {
              this.$refs.solveUser_3.setUserId(this.searchData.solveUserId);
            }

            if ( _v.ticketCreateTimeBegin ) {
              this.ticketCreateTimeRange = [ _v.ticketCreateTimeBegin, _v.ticketCreateTimeEnd ];
            }

            if ( _v.ticketUpdateTimeBegin ) {
              this.ticketUpdateTimeRange = [ _v.ticketUpdateTimeBegin, _v.ticketUpdateTimeEnd ];
            }
          }, 500);
        },

        // 选择日期
        ticketCreateTimeChange(item) {
            if(item != '' && item != null && item != undefined) {
                this.searchData.ticketCreateTimeBegin = item[0]
                this.searchData.ticketCreateTimeEnd = item[1]
            } else {
                this.searchData.ticketCreateTimeBegin = ''
                this.searchData.ticketCreateTimeEnd = ''
            }
        },

        ticketUpdateTimeChange(item) {
            if(item != '' && item != null && item != undefined) {
                this.searchData.ticketUpdateTimeBegin = item[0]
                this.searchData.ticketUpdateTimeEnd = item[1]
            } else {
                this.searchData.ticketUpdateTimeBegin = ''
                this.searchData.ticketUpdateTimeEnd = ''
            }
        },

        clickAdvancedSearch() {
            this.advancedSearch = !this.advancedSearch;

            localStorage.setItem(CacheUtil.AdvancedSearch, this.advancedSearch + "");
        },

        // 查询工单状态
        getOrderStatus() {
            var self = this;
            sdk.TicketStatusApi().listCached({
                page: {}
            }).then(res => {
                self.orderStatusList = res.concat({"name":"状态为空","value":'ticket-status-is-null'});
            });
        },

        doSearch() {
            this.$emit('search');
        },

        // 选择处理人回调-查询
        onDealUserIdChange(value) {
            this.searchData.dealUserId = value;
        },

        // 选择处理人回调-查询
        onTicketCcChange(value) {
            this.searchData.ticketCcId = value;
        },

        // 选择处理人回调-查询
        updateSolveUserId(value) {
            this.searchData.solveUserId = value;
        },

        // 选择创建人回调-查询
        onCreatorIdChange(value) {
            this.searchData.creatorId = value;
        },

        resetSearch() {
            this.$refs.creatorUser_3.clearValue();
            this.$refs.assignUser_3.clearValue();
            this.$refs.solveUser_3.clearValue();
            this.$refs.ticketCc_71.clearValue();

            this.ticketCreateTimeRange = '';
            this.ticketUpdateTimeRange = '';

            this.$emit('reset');
        },

        doExport( _command ) {
            this.$emit('export', _command);
        }
    },

    mounted() {
        this.setSearchData(this.value);

        this.getOrderStatus();
    },

    watch: {
        value() {
            this.setSearchData(this.value);
        },

        searchData() {
            // console.log('#240 watch.searchData', this.searchData);

            this.$emit('input', this.searchData);
        }
    }
}
</script>

<style>
  .TicketNewBtn {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketSearchForm.vue